const routePreloaders = {
  "/": () => import("../pages/home/page"),
  "/compute/amd-epyc": () => import("../pages/compute/compute-amd-epyc/page"),
  "/compute/intel-gold": () => import("../pages/compute/compute-intel-gold/page"),
  "/networking": () => import("../pages/networking/page"),
  "/one-click-apps": () => import("../pages/one-click-apps/page"),
  "/products/object-storage": () => import("../pages/products/object-storage/page"),
  "/storage/integrations": () => import("../pages/storage/integrations/page"),
  "/data-centers/chennai": () => import("../pages/data-centers/chennai/page"),
  "/pricing": () => import("../pages/pricing/page"),
  "/about": () => import("../pages/about/page"),
  "/contact": () => import("../pages/contact/page"),
  "/resources/tutorials": () => import("../pages/resources/tutorials/page"),
  "/resources/compare-providers": () => import("../pages/resources/compare-providers/page"),
  "/legal/privacy-policy": () => import("../pages/legal/privacy-policy/page"),
  "/legal/acceptance-usage-policy": () => import("../pages/legal/acceptance-user-policy/page"),
  "/legal/kyc-verification": () => import("../pages/legal/kyc-verification/page"),
  "/legal/service-level-agreement": () => import("../pages/legal/service-level-agreement/page"),
  "/sitemap": () => import("../pages/sitemap/page"),
  "/testimonials": () => import("../pages/testimonials/page"),
};

const preloadedRoutes = new Set();

const resolvePreload = (path) => {
  const normalizedPath = path?.split("?")[0]?.split("#")[0];

  if (routePreloaders[normalizedPath]) {
    return { cacheKey: normalizedPath, preload: routePreloaders[normalizedPath] };
  }

  if (normalizedPath?.startsWith("/resources/tutorials")) {
    return {
      cacheKey: "/resources/tutorials",
      preload: routePreloaders["/resources/tutorials"],
    };
  }

  return null;
};

const preloadRoute = (path) => {
  const resolved = resolvePreload(path);

  if (!resolved || preloadedRoutes.has(resolved.cacheKey)) {
    return;
  }

  preloadedRoutes.add(resolved.cacheKey);
  resolved.preload();
};

export default preloadRoute;
